import { render, staticRenderFns } from "./InfoPill.vue?vue&type=template&id=64584f12&scoped=true&lang=pug"
import script from "./InfoPill.vue?vue&type=script&lang=js"
export * from "./InfoPill.vue?vue&type=script&lang=js"
import style0 from "./InfoPill.vue?vue&type=style&index=0&id=64584f12&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64584f12",
  null
  
)

export default component.exports